import axios from 'axios';
import { axiosInstanceV2 } from '../axios';
import { IAgreement } from '../dashboard/types';
import { IActivity, IPromotion, RequestParameters } from '../types';
import { getNonPaginatedEndpoint } from '../utils';

export interface IAddress {
  street: string;
  country: string;
  city: string;
  state: string;
  neighborhood: string;
  cep: string;
  formattedAddress: string;
}

export function getLanding(slug: string, type: string = 'club'): Promise<IAgreement> {
  return getNonPaginatedEndpoint(`/landings/?slug=${slug}&type=${type}`) as Promise<IAgreement>;
}

export function getPromotions(params?: RequestParameters): Promise<IPromotion[]> {
  return getNonPaginatedEndpoint(`/promotion/promotions/`, params, axiosInstanceV2) as Promise<IPromotion[]>;
}

export function getActivities(): Promise<IActivity[]> {
  return getNonPaginatedEndpoint(`/activities/`, {}, axiosInstanceV2) as Promise<IActivity[]>;
}

export function getCurrentAddressFromLatLong(latitude: number | string, longitude: number | string): Promise<IAddress> {
  return axios
    .get(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyB5tXrkiapXmzmvkkW0-7MQvfx1LL9VScQ`
    )
    .then(({ data: address }: { data: Record<string, any> }) => {
      const mappedAddress = {
        street: '',
        country: '',
        city: '',
        state: '',
        neighborhood: '',
        cep: '',
        formattedAddress: address.results[0].formatted_address,
      };

      const location: Record<string, string>[] = address.results.filter((r: any) => r.types.includes('street_address'));

      if (location.length === 0) throw Error('Não foi possível parsear a localização');

      mappedAddress.formattedAddress = location[0].formatted_address;

      return mappedAddress;
    });
}
